import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Fade } from "react-awesome-reveal";
import CompliantCommittedImage from '../../assets/CompliantCommitted.png';
import ClientCentricResearchImage from '../../assets/ClientCentricResearch.png';
import ExperiencedLeadershipImage from '../../assets/ExperiencedLeadership.png';
import DepthMarketAnalysisImage from '../../assets/DepthMarketAnalysis.png';
import ClarityComplexityImage from '../../assets/ClarityComplexity.png';
import AdaptiveEvolvingInsightsImage from '../../assets/AdaptiveEvolvingInsights.png';

const benefitsData = [
  {
    img: CompliantCommittedImage,
    title: 'Compliant & Committed',
    text: 'As a SEBI-registered Research Analyst, we uphold the highest compliance standards, ensuring transparency and integrity in every market insight we provide.'
  },
  {
    img: ClientCentricResearchImage,
    title: 'Client-Centric Research',
    text: 'Our research follows a client-centric approach—delivering focused market intelligence shaped by investor needs, not market noise.'
  },
  {
    img: ExperiencedLeadershipImage,
    title: 'Experienced Leadership',
    text: 'With a proven track record in market research and analysis, our leadership team ensures that every recommendation is backed by expertise and diligence.'
  },
  {
    img: DepthMarketAnalysisImage,
    title: 'In-depth Market Analysis',
    text: 'We go beyond stock movements, leveraging fundamental, technical, and macroeconomic research to provide clear, actionable insights.'
  },
  {
    img: ClarityComplexityImage,
    title: 'Clarity in Complexity',
    text: 'Markets can be unpredictable - we break down the noise, offering structured research that empowers you to make informed investment decisions.'
  },
  {
    img: AdaptiveEvolvingInsightsImage,
    title: 'Adaptive & Evolving Insights',
    text: 'Our recommendations evolve with market trends, ensuring you receive timely, well-researched strategies for every market condition.'
  },
];

function BenefitsSection() {
  return (
    <div className="benefits-section section-padding">
      <Container className="text-center">
        <Fade triggerOnce direction="down">
          {/* <p className="text-light-blue mb-2">Benefits</p> */}
                      {/* h2: the page's single h1 lives in HeroSection (docx round-2) */}
                      <h2 className="contact-section-title">Why Right Spade?</h2>
        </Fade>

        <Row xs={1} md={2} lg={3} className="g-4 mt-4 ">
          {benefitsData.map((benefit, index) => (
            <Col key={index}>
              <Fade triggerOnce delay={index * 100} cascade={false} direction="up">
                <Card className="h-100">
                  {/* Use Card.Img or a div with background-image for better control */}
                  <Card.Img variant="top" src={benefit.img} alt={benefit.title} />
                  <Card.Body style={{textAlign: 'justify'}}> {/* text-start for left align */}
                    <Card.Title>{benefit.title}</Card.Title>
                    <Card.Text>{benefit.text}</Card.Text>
                  </Card.Body>
                </Card>
              </Fade>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default BenefitsSection;